
/**
 * class RadioSelector
 * Combines all the visibility conditions
 */
class RadioSelector {
	static dataSelector = 'data-radio-select-settings';
	/**
	 * get lazy load elements
	 * @returns {NodeListOf<Element>}
	 */
	static getElements() {
		return document.querySelectorAll( 'input[' + RadioSelector.dataSelector + ']' );
	}

	/**
	 * get settings data
	 *
	 * @param {HTMLElement} element
	 * @returns {any}
	 */
	static getData( element ) {
		return JSON.parse( element.getAttribute( RadioSelector.dataSelector ) );
	}

	static toggleSelection( event, item, element ) {
		let selectedValue = item.dataset.radioValue || false;
		if ( ! selectedValue ) {
			return;
		}
		selectedValue = selectedValue.trim();
		let value = element.value;
		let on = true;
		if ( ! value.includes( selectedValue ) ) {
			// value not in selected yet

			if ( ! value ) {
				// empty value, just set
				RadioSelector.setValue( item, element, selectedValue, on );
				return;
			}
			// check limit
			const { limit  = '' } = RadioSelector.getData( element ),
				count = value.split( ', ' ).length;
			if ( ! limit || count < limit ) {
				// here we already have value so append
				value += `, ${selectedValue}`;
			} else {
				on = false;
			}
		} else {
			// already selected so lets remove it
			on = false;
			value = value.split( ', ' ).filter( val => val !== selectedValue ).join( ', ' );
		}
		RadioSelector.setValue( item, element, value, on );
	}

	static triggerToggleEvents( item, element, value, on, before = true ) {
		const onToggle = new CustomEvent( `RadioSelector/${on ? 'on' : 'off'}/${ before ? 'before': 'after'}`, {
			bubbles: true,
			detail: {
				value,
				element,
				item,
				activeState: on,
			}
		} );
		document.dispatchEvent( onToggle );

	}

	static setValue ( item, element, value, on = false ) {
		element.value = value;
		const { selectedClass  = '' } = RadioSelector.getData( element );
		this.triggerToggleEvents( item, element, value, on );
		if ( on ) {
			item.classList.add( selectedClass );
		} else {
			item.classList.remove( selectedClass );
		}
		this.triggerToggleEvents( item, element, value, on, false );
	}

	/**
	 * init
	 */
	init() {
		RadioSelector.getElements().forEach( ( element ) => {
			const {
				wrapperSelector = '',
				hiddenClass = '',
				itemSelector = '',
				chooseSelector = '',
			} = RadioSelector.getData( element );
			const wrapper = document.querySelector( wrapperSelector );
			if ( ! wrapper ) {
				return;
			}

			// remove label
			element.previousElementSibling.remove();
			// move wrapper element to the form
			element.parentElement.appendChild( wrapper );

			wrapper.querySelectorAll( `${wrapperSelector} ${itemSelector}`  ).forEach( ( item ) => {
				item.querySelectorAll( chooseSelector ).forEach( trigger => {
					trigger.addEventListener( 'click', ( e ) => RadioSelector.toggleSelection( e, item, element ) );
				} );
			} );

			// show section
			wrapper.classList.remove( hiddenClass );
		} );
	}

}

new RadioSelector().init();
